import { render, staticRenderFns } from "./region-goods-edit.vue?vue&type=template&id=73a3147a"
import script from "./region-goods-edit.vue?vue&type=script&lang=js"
export * from "./region-goods-edit.vue?vue&type=script&lang=js"
import style0 from "./region-goods-edit.vue?vue&type=style&index=0&id=73a3147a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports